export const MuiBadge = {
	variants: [
		{
			props: { variant: "inline" },
			style: {
				"& .MuiBadge-badge": {
					position: "unset",
					transform: "none",
				},
			},
		},
		{
			props: { color: "white" },
			style: {
				"& .MuiBadge-badge": {
					backgroup: "var(--white)",
				},
			},
		},
		{
			props: { color: "none" },
			style: {
				"& .MuiBadge-badge": {
					background: "none",
				},
			},
		},
	],
};
